"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopHandleErrors = exports.handleErrors = exports.HttpError = exports.ApiError = void 0;
/** validateResponse为false */
var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = _this.constructor.name;
        return _this;
    }
    return ApiError;
}(Error));
exports.ApiError = ApiError;
/** 4xx / 5xx */
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = _this.constructor.name;
        return _this;
    }
    return HttpError;
}(Error));
exports.HttpError = HttpError;
var __handleErrors = function (event, level) {
    [ApiError, HttpError].some(function (Err) {
        if (event.reason instanceof Err) {
            event.preventDefault();
            if (level !== false) {
                if (level === void 0) {
                    level = 'warn';
                }
                console[level](event.reason);
            }
            return true;
        }
        return false;
    });
};
var ErrorListener;
/** 兜底接口错误，然后以console[level]打印 */
var handleErrors = function (level) {
    if (!window)
        return;
    // 注销之前的listener
    if (ErrorListener)
        window.removeEventListener('unhandledrejection', ErrorListener);
    ErrorListener = function (event) { return __handleErrors(event, level); };
    window.addEventListener('unhandledrejection', ErrorListener);
};
exports.handleErrors = handleErrors;
var stopHandleErrors = function () {
    ErrorListener && window && window.removeEventListener('unhandledrejection', ErrorListener);
};
exports.stopHandleErrors = stopHandleErrors;
